<template lang="pug">
.usage-fees-group-home-insured-service-costs-table
  .d-flex.flex-row.align-items-center
    .title.mr-1 介護保険給付サービス利用料（1割負担の金額、月額）
    span.validation-label 必須
  .d-flex.flex-row.align-items-center.mb-2
    div 2割負担の場合は2倍、3割負担の場合は3倍して募集ページで表示
  b-table-simple.dark-boder-table.waiter-judge-template-table
    b-thead
      b-tr
        b-th 部屋種類
        b-th 要支援1
        b-th 要支援2
        b-th 要介護1
        b-th 要介護2
        b-th 要介護3
        b-th 要介護4
        b-th 要介護5
    b-tbody
      UsageFeesGroupHomeInsuredServiceCostsTableRow(v-if="showRomType('multiBed')" v-model="_value.multiBed" roomId="multiBed" roomName="従来型多床室")
      UsageFeesGroupHomeInsuredServiceCostsTableRow(v-if="showRomType('conventinalSingle')" v-model="_value.conventinalSingle" roomId="conventinalSingle" roomName="従来型個室")
      UsageFeesGroupHomeInsuredServiceCostsTableRow(v-if="showRomType('unitTypeSingle')" v-model="_value.unitTypeSingle" roomId="unitTypeSingle" roomName="ユニット型個室")
      UsageFeesGroupHomeInsuredServiceCostsTableRow(v-if="showRomType('double')" v-model="_value.double" roomId="double" roomName="２人部屋（夫婦部屋）")
      UsageFeesGroupHomeInsuredServiceCostsTableRow(v-if="showRomType('single')" v-model="_value.single" roomId="single" roomName="個室")

      UsageFeesGroupHomeInsuredServiceCostsTableRow(v-for="(customRoom, index) in _value.customRecruitmentRoom" v-model="_value.customRecruitmentRoom[index]"
        :key="customRoom.id" :roomId="customRoom.id" :roomName="customRoom.roomName")

  .errors(v-for="fieldName in _fieldNames")
    .error-messages(v-for="error in errors.collect(fieldName)")
      .error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { InsuredServiceCosts } from "@/commons/services/WaiterRecruitments";
import { FacilityGetModel } from "@/commons/services/Facilities";

import UsageFeesGroupHomeInsuredServiceCostsTableRow from "@/pc/containers/waiters/UsageFeesGroupHomeInsuredServiceCostsTableRow.vue";

/**
 * ### 料金シミュレーション(特養タイプ) 部屋料金コンポーネント
 */
@Component({
  components: {
    UsageFeesGroupHomeInsuredServiceCostsTableRow
  }
})
export default class UsageFeesGroupHomeInsuredServiceCostsTable extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: InsuredServiceCosts;

  @Prop()
  facility!: FacilityGetModel;

  get _value(): InsuredServiceCosts {
    return this.value;
  }

  set _value(newValue: InsuredServiceCosts) {
    this.$emit("input", newValue);
    return;
  }

  get _fieldNames(): string[] {
    let fieldNames: string[] = [];
    fieldNames = fieldNames.concat(this.createFieldNames("multiBed"));
    fieldNames = fieldNames.concat(this.createFieldNames("conventinalSingle"));
    fieldNames = fieldNames.concat(this.createFieldNames("unitTypeSingle"));
    fieldNames = fieldNames.concat(this.createFieldNames("single"));
    fieldNames = fieldNames.concat(this.createFieldNames("double"));

    return fieldNames;
  }

  public createFieldNames(roomName: string): string[] {
    return [
      `usage-fees-group-home-${roomName}-supportLevel_1`,
      `usage-fees-group-home-${roomName}-supportLevel_2`,
      `usage-fees-group-home-${roomName}-careLevel_1`,
      `usage-fees-group-home-${roomName}-careLevel_2`,
      `usage-fees-group-home-${roomName}-careLevel_3`,
      `usage-fees-group-home-${roomName}-careLevel_4`,
      `usage-fees-group-home-${roomName}-careLevel_5`
    ];
  }

  /**
   * ### 施設が表示対象にしている部屋種類か否かを返す
   */
  public showRomType(roomTypeName: string): boolean {
    switch (roomTypeName) {
      case "multiBed": {
        return this.facility.recruitmentRoom.multiBed;
      }
      case "conventinalSingle": {
        return this.facility.recruitmentRoom.conventinalSingle;
      }
      case "unitTypeSingle": {
        return this.facility.recruitmentRoom.unitTypeSingle;
      }
      case "double": {
        return this.facility.recruitmentRoom.double;
      }
      case "single": {
        return this.facility.recruitmentRoom.single;
      }
      default: {
        return false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-group-home-insured-service-costs-table {
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
}
</style>
